import moment from "moment";
import React, { useContext, useEffect, useState, useRef } from "react";
import { withTranslation } from "react-i18next";
import { Button, Dropdown, Form, OverlayTrigger, ProgressBar, Table, Breadcrumb } from "react-bootstrap";
import { BsFileEarmarkZip, BsFileEarmarkSpreadsheet, BsFlagFill, BsGridFill, BsFilter, BsEye, BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import { BiDownload, BiPencil, BiBullseye } from "react-icons/bi";
import { FaList } from "react-icons/fa";
import './DataViewGrid.scss';
import { useLocation, useParams } from "react-router-dom";
import { LoaderContext } from "../../../App";
import KPIService from "../../../core/service/KPIService";
import Utils from "../../../core/utilities/Utils";
import { useNavigate } from "react-router-dom";

const DataViewGridGoalDetails = ({ t }) => {
	const location = useLocation();
	const { setLoaderDisplay } = useContext(LoaderContext);
	const [kpis, setKPIs] = useState({});
	const [expandKpis, setExpandKpis] = useState({});
	const [expandActions, setExpandActions] = useState(true);

	const navigate = useNavigate();
	const { goalId } = useParams();

	useEffect(() => {
		fetchKPIsForGoal(goalId);
	}, [goalId]);

	useEffect(() => {
		if (kpis?.length > 0) {
			const initialExpandState = kpis.reduce((acc, kpi) => {
				acc[kpi.id] = true;
				return acc;
			}, {});
			setExpandActions(initialExpandState);
		}
	}, [kpis]);

	const fetchKPIsForGoal = (goalId) => {
		setLoaderDisplay(true);
		KPIService.getKPIs(goalId).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			setKPIs(res.data.data);
		}).catch(err => {
			setLoaderDisplay(false);
		});
	};

	const toggleExpandAction = (kpiId) => {
		setExpandActions(prevState => ({
			...prevState,
			[kpiId]: !prevState[kpiId],
		}));
	};

	const StatusView = () => {
		navigate({
			pathname: "/company_admin/statusview",
		});
	}

	const getKpiStatusClass = (status) => {
		switch (status) {
			case 'ON_TRACK':
				return 'bg-success';
			case 'OFF_TRACK':
				return 'bg-danger';
			case 'NEAR_TRACK':
				return 'bg-warning';
			default:
				return 'bg-secondary';
		}
	};

	const getGoalStatusText = (status) => {
		switch (status) {
			case 'On track':
				return 'On Track';
			case 'Off-track':
				return 'Off Track';
			case 'At risk':
				return 'At Risk';
			case 'Achieved':
				return 'Achieved';
			case 'Exceeded target':
				return 'Exceeded Target';
			default:
				return status;
		}
	};
	
	const getKpiStatusText = (status) => {
		switch (status) {
			case 'ON_TRACK':
				return 'On Track';
			case 'OFF_TRACK':
				return 'Off Track';
			case 'NEAR_TRACK':
				return 'Near Track';
			default:
				return status;
		}
	};

	const toggleViews = (view) => {
		if (view === 'dataView') {
			navigate(`/company_admin/kpidataview/goal/${goalId}`, { state: { goal: location.state.goal } });
		} else if (view === 'analyticalView') {
			navigate(`/company_admin/dashboard/goal/${goalId}`, { state: { goal: location.state.goal } });
		}
	}

	return (
		<div className="DataViewGridGoalDetails">
			<div className="List_header mb-1">
				<div>
					<Breadcrumb className="h5 m-0">
						<Breadcrumb.Item onClick={() => StatusView()}>{t("Status.label")}</Breadcrumb.Item>
						<Breadcrumb.Item active>{location.state.goal.name}</Breadcrumb.Item>
					</Breadcrumb>
				</div>

				<div className="header-actions">
					<div className="ToggleBtn">
						<Form.Check
							className="toggle-switch"
							inline
							label="Status "
							name="assessType"
							type="radio"
							id="statusView"
							checked
						/>
						<Form.Check
							className="toggle-switch"
							inline
							label="Analytical "
							name="assessType"
							type="radio"
							id="analyticalView"
							onChange={(e) => toggleViews(e.target.id)}
						/>
						<Form.Check
							className="toggle-switch"
							inline
							label="Data "
							name="assessType"
							type="radio"
							id="dataView"
							onChange={(e) => toggleViews(e.target.id)}
						/>
					</div>
				</div>
			</div>
			<div className="DataViewGridGoalDetails_card">
				<div className="MainGoalCard">
					<div className="MainGoalCard_head">
						<div className="flagBox">
							<BsFlagFill />
						</div>
						<h6>{location.state.goal.name}</h6>
						<small>{location.state.goal.timelineStart ? moment(location.state.goal.timelineStart).format('MMM DD, YYYY') : ''} - {location.state.goal.timelineEnd ? moment(location.state.goal.timelineEnd).format('MMM DD, YYYY') : ''}</small>
						<div className="trackDt_bar">
							<h6>
								{getGoalStatusText(location.state.goal.status)}
							</h6>
							<ProgressBar now={location.state.goal.percentage} label={`${location.state.goal.percentage}%`} />
							{/* <span>at 1,000 towards 0 tCO2-e/ft2</span> */}
						</div>
						{
							kpis?.length > 0 &&
							<div className=" Actions_btn">
								<span className="cursor" onClick={() => setExpandKpis(!expandKpis)}>
									{expandKpis ? (
										<BsFillCaretUpFill className="me-1" />
									) : (
										<BsFillCaretDownFill className="me-1" />
									)}
									{kpis.length} {t("KPIs.label")}
								</span>
							</div>
						}
					</div>
					{
						expandKpis && kpis?.length > 0 &&
						<div className="MainGoalCard_body">
							{
								kpis.map(kpi => (
									<div className="MainKPICard" key={kpi.id}>
										<div className="flagBox">
											<BsGridFill />
										</div>
										<div className="row mx-0">
											<div className="col-md-6 p-2  pb-0">
												<h6>{kpi.name} </h6>
												<small>{kpi.timelineStart ? moment(kpi.timelineStart).format('MMM DD, YYYY') : ''} - {kpi.timelineEnd ? moment(kpi.timelineEnd).format('MMM DD, YYYY') : ''}</small>
												<span className={`badge ms-2 ${getKpiStatusClass(kpi.status)}`}>
													{getKpiStatusText(kpi.status)}
												</span>
											</div>

											<div className="col-md-4 p-2 pb-0 pt-1">
												<div className="SubtrackDt_bar">
													<div className="Actual_valueBox">
														<div className="text-left d-flex align-items-center">
															<small className="me-2">Total </small>
															<h6 className="me-1">{kpi.actual}</h6> / <h6 className="ms-1">{kpi.unit}</h6>
														</div>
														<span><BiBullseye className="me-1" />{kpi.target}</span>
													</div>
													<div className="target-progress-bar">
														<div className="stacking-group">
															<ProgressBar variant="danger" now={kpi.percentage} label={`${kpi.percentage}%`} />
															<div className="progress-bar-target-tick" style={{ left: "40%" }}>
																<div className="tick">
																	<BsFillCaretUpFill />
																</div>
															</div>
															<div className="progress-bar-target-tick" style={{ left: "70%" }}>
																<div className="tick">
																	<BsFlagFill className="redFlag" />
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="col-md-8 p-2 py-2">
												{
													kpi?.actions?.length > 0 &&
													<div className="Actions_btn">
														<span className="cursor" onClick={() => toggleExpandAction(kpi.id)}>
															{expandActions[kpi.id] ? (
																<BsFillCaretUpFill className="me-1" />
															) : (
																<BsFillCaretDownFill className="me-1" />
															)}
															{kpi.actions.length} {t("Actions.label")}
														</span>
													</div>
												}

												{
													expandActions[kpi.id] && kpi?.actions?.length > 0 &&
													<div className="KpiActionCard">
														{
															kpi.actions.map(action => (
																<div className="KpiActionCard_inner" key={action.id}>
																	<div className="row mx-0 align-items-center">
																		<div className="col-md-6 p-2">
																			<h6>{action.name}</h6>
																		</div>
																		<div className="col-md-3 p-2">
																			<div className="Kpi_targetBox">
																				<ProgressBar now={action.progressSummary.lastRecordedProgress} label={`${action.progressSummary.lastRecordedProgress}%`} />
																				{/* <b>68%</b> */}
																			</div>
																		</div>
																		<div className="col-md-3 p-2">
																			<div className="Prograss_assigneeBOx">
																				<ul>
																					{
																						action.assignees.map(assignee => (
																							<li key={assignee.id}>
																								<span>{Utils.getTextBasedProfilePic(assignee.assigneeName)}</span>
																							</li>
																						))
																					}
																				</ul>
																			</div>
																		</div>
																	</div>
																</div>
															))
														}
													</div>
												}
											</div>
										</div>
										{/* Commented lines of code below are required for future use */}

										{/* <button className="btn KpiEdit_Btn">
											<BiPencil />
										</button> */}
									</div>
								))
							}
						</div>
					}
				</div>
			</div>
		</div>
	);
};






export default withTranslation()(DataViewGridGoalDetails);